import React from 'react';
export const FAQSections = () => {
  return <section className="mb-12" data-id="element-159">
      <div className="mb-10" data-id="element-160">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-161">
          "Is er een specifiek moment waarop het kwartje valt?"
        </h2>

        <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-162">
          Er is een specifiek moment tijdens elk webinar dat Amee het
          "omslagpunt" noemt. Meestal rond minuut 20, wanneer ze een aantal
          misvattingen over dominantie uit de wereld helpt.
        </p>

        <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-163">
          <p className="text-gray-800 leading-relaxed italic" data-id="element-164">
            "Dan zie ik in de chat dat het kwartje valt," vertelt ze. "Mensen
            typen dingen als 'OMG, daarom doet hij dat!' of 'Dit verklaart
            alles!' Dat is het moment waarop ze overschakelen van problemen zien
            naar communicatie begrijpen."
          </p>
        </div>
      </div>

      <div className="mb-10" data-id="element-165">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-166">
          "Wat zeggen mensen één week na het webinar?"
        </h2>

        <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-167">
          De echte test van de "90-minuten transformatie" komt in de dagen na
          het webinar. Kunnen mensen de nieuwe inzichten toepassen? Maken ze
          echt verschil?
        </p>

        <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-4 rounded-r-lg" data-id="element-168">
          <p className="text-gray-800 leading-relaxed italic" data-id="element-169">
            "Binnen drie dagen waren onze wandelingen compleet veranderd,"
            vertelt Jeroen uit Rotterdam. "In plaats van Max corrigeren ging ik
            luisteren naar wat hij probeerde te zeggen. Nu zijn wandelingen
            ontspannen in plaats van stressvol."
          </p>
        </div>

        <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-170">
          <p className="text-gray-800 leading-relaxed italic" data-id="element-171">
            Emma uit Gent: "Het grappige is dat Mila niet veranderd is - ik
            begrijp haar gewoon beter. Waardoor zij zich ook rustiger voelt. Het
            is een opwaartse spiraal."
          </p>
        </div>
      </div>
    </section>;
};